// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2233":"b814c0a3cb0486e0","3261":"558df96011758af8"}[chunkId] + ".css";
};